module.exports = {
  siteTitle: 'The Official Site of Kaushal Parikh',
  siteDescription:
    'The Official Site of Kaushal Parikh',
  siteKeywords:
    'Kaushal Parikh, Kaushal, Parikh, kparikh9, software engineer, rutgers',
  siteUrl: 'https://kparikh9.github.io',
  siteLanguage: 'en_US',

  googleVerification: 'DCl7VAf9tcz6eD9gb67NfkNnJ1PKRNcg8qQiwpbx9Lk',

  name: 'Kaushal Parikh',
  location: 'New Brunswick, NY',
  email: 'kaushalnparikh@gmail.com',
  socialMedia: [
    {
      name: 'Github',
      url: 'https://github.com/kparikh9/',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/kaushal-parikh/',
    },
  ],

  nav: [
    {
      name: 'About',
      url: '#about',
    },
    {
      name: 'Experience',
      url: '#jobs',
    },
    // {
    //   name: 'Work',
    //   url: '#projects',
    // },
    {
      name: 'Contact',
      url: '#contact',
    },
  ],

  googleAnalyticsID: 'UA-45666519-2',

  headerHeight: 100,

  greenColor: '#64ffda',
  navyColor: '#0a192f',
  darkNavyColor: '#020c1b',

  srConfig: (delay = 200) => {
    return {
      origin: 'bottom',
      distance: '20px',
      duration: 500,
      delay,
      rotate: { x: 0, y: 0, z: 0 },
      opacity: 0,
      scale: 1,
      easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
      mobile: true,
      reset: false,
      useDelay: 'always',
      viewFactor: 0.25,
      viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
    };
  },
};
